import React, { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  TagsWrapper,
  FilterTagWrapper,
  ResetFiltersCTA,
  ResetLabel,
  FilterTag,
  Label,
  IconBox,
} from './FilterTags.style';
import { clearAllFilters, selectFilters, removeFilter } from '../../reducers/filtersReducer';
import useFilterTagProcessor from '../../hooks/useFilterTagProcessor';
import useFilterOptions from '../../hooks/useFilterOptions';
import CloseIcon from '../../assets/icons/CloseIcon';
import {
  filterClearIndividual,
  filterClearAll,
  filterCurrentState,
} from '../../utils/analyticsEventListeners';
import { INTIAL_FILTERS } from '../../constants/initialFilters';
// type FilterResultsProps = {};

const FilterTags: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { listOfAllFilters } = useFilterOptions();
  const { confirmedFilters } = useSelector(selectFilters);

  const { renderStringFilters, filterCount } = useFilterTagProcessor(
    confirmedFilters,
    listOfAllFilters,
  );

  const resetAllFilters = useCallback(() => {
    filterClearAll(confirmedFilters);
    dispatch(clearAllFilters());
    filterCurrentState(INTIAL_FILTERS);
    // Reload main dealer id
  }, [confirmedFilters, dispatch]);

  const handleRemoveFilter = useCallback(
    (filterType: string, filter: string) => {
      filterClearIndividual(confirmedFilters, `${filterType}.${filter}`);
      // CHANGE LATER
      dispatch(removeFilter({ filterType, filterValue: filter }));
    },
    [confirmedFilters, dispatch],
  );

  const resetFiltersComponent = useMemo(() => {
    return (
      <ResetFiltersCTA data-testid="filter-tags-list">
        <ResetLabel onClick={resetAllFilters}>{t('promo.filterTags.resetAll')}</ResetLabel>
      </ResetFiltersCTA>
    );
  }, [resetAllFilters, t]);

  const shouldShowRemoveAllFilters = !!filterCount;

  const renderContent = useMemo(() => {
    if (!filterCount) return <></>;
    return (
      <TagsWrapper>
        <FilterTagWrapper data-testid="filter-tags-list">
          {shouldShowRemoveAllFilters && resetFiltersComponent}
          {renderStringFilters.map((filter) => {
            const { label, filterType, value, showType, preLabel } = filter;
            return (
              <FilterTag key={`${filterType}+${label}+${value}`}>
                <Label>
                  {showType && `${preLabel}:`} {label}
                </Label>
                <IconBox onClick={() => handleRemoveFilter(filterType, value)}>
                  <CloseIcon size={12} />
                </IconBox>
              </FilterTag>
            );
          })}
        </FilterTagWrapper>
      </TagsWrapper>
    );
  }, [
    filterCount,
    handleRemoveFilter,
    renderStringFilters,
    resetFiltersComponent,
    shouldShowRemoveAllFilters,
  ]);

  return renderContent;
};

export default FilterTags;
